import { call, put, takeLatest } from 'redux-saga/effects'
import * as types from '../../../actions/index.types'
import { toast } from 'react-toastify';
import * as req from '../../../../axios/request/SocietyPortal/CashBankReqs/CashBankReqs'

function* getCashBankList(action) {
    try {
        const result = yield call(req.getCashBankListReq, action);
        if (result.success === true) {
            yield put({ type: types.GET_CASH_BANK_LIST_SUCCESS, payload: result });
        } else {
            yield put({ type: types.GET_CASH_BANK_LIST_FAILURE, message: result?.message });
            toast.error(result?.message || "Failed to fetch cash & bank accounts");
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.GET_CASH_BANK_LIST_FAILURE, message: e?.message });
        toast.error(e?.message || "Something went wrong");
    }
}

function* getCashBankEntries(action) {
    try {
        const result = yield call(req.getCashBankEntriesReq, action);
        if (result.success === true) {
            yield put({ type: types.GET_CASH_BANK_ENTRIES_SUCCESS, payload: result });
        } else {
            yield put({ type: types.GET_CASH_BANK_ENTRIES_FAILURE, message: result?.message });
            toast.error(result?.message || "Failed to fetch entries");
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.GET_CASH_BANK_ENTRIES_FAILURE, message: e?.message });
        toast.error(e?.message || "Something went wrong");
    }
}

function* getCashBankSummary(action) {
    try {
        const result = yield call(req.getCashBankSummaryReq, action);
        if (result.success === true) {
            yield put({ type: types.GET_CASH_BANK_SUMMARY_SUCCESS, payload: result });
        } else {
            yield put({ type: types.GET_CASH_BANK_SUMMARY_FAILURE, message: result?.message });
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.GET_CASH_BANK_SUMMARY_FAILURE, message: e?.message });
    }
}

export default function* CashBankSaga() {
    yield takeLatest(types.GET_CASH_BANK_LIST, getCashBankList);
    yield takeLatest(types.GET_CASH_BANK_ENTRIES, getCashBankEntries);
    yield takeLatest(types.GET_CASH_BANK_SUMMARY, getCashBankSummary);
}
